import React, { ComponentProps } from 'react'

import { MemberProps } from '../convention'
import LineItemImage from '../LineItem/Image'

const CategorySegmentImage: React.FC<
  MemberProps<Pick<ICategorySegment, 'image' | 'label'>, ComponentProps<typeof LineItemImage>>
> = ({ member, props }) => {
  return (
    <LineItemImage
      member={{ image_url: member.image, name: member.label }}
      props={{
        width: 48,
        height: 48,
        ...props
      }}
    />
  )
}

export default CategorySegmentImage
